import { render, staticRenderFns } from "./MassImport.vue?vue&type=template&id=4ed6c172&scoped=true&"
import script from "./MassImport.vue?vue&type=script&lang=ts&"
export * from "./MassImport.vue?vue&type=script&lang=ts&"
import style0 from "./MassImport.vue?vue&type=style&index=0&id=4ed6c172&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6c172",
  null
  
)

export default component.exports